import React, { useState } from 'react';
import { RolePermissionsTab } from '../components/permissions/RolePermissionsTab';
import { UserOverridesTab } from '../components/permissions/UserOverridesTab';

export const Permissions: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'roles' | 'users'>('roles');

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Permissions</h1>
        <p className="text-gray-500 mt-1">
          Configure page-level permissions for roles and individual users
        </p>
      </div>

      <div className="flex gap-1 mb-6 bg-gray-100 p-1 rounded-lg w-fit">
        <button
          onClick={() => setActiveTab('roles')}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
            activeTab === 'roles'
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          Role Permissions
        </button>
        <button
          onClick={() => setActiveTab('users')}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
            activeTab === 'users'
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          User Overrides
        </button>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6">
        {activeTab === 'roles' ? <RolePermissionsTab /> : <UserOverridesTab />}
      </div>
    </div>
  );
};
